module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon4.39bc1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon4.png
// module id = jpB8
// module chunks = 0